//Auth
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const FETCH_ALL_PRODUCTS_SUCCESS = "FETCH_ALL_PRODUCTS_SUCCESS";
export const FETCH_SINGLE_PRODUCT_SUCCESS = "FETCH_SINGLE_PRODUCT_SUCCESS";
export const FETCH_ALL_CATEGORIES_SUCCESS = "FETCH_ALL_CATEGORIES_SUCCESS";
export const FETCH_ALL_BRANDS_SUCCESS = "FETCH_ALL_BRANDS_SUCCESS";
export const FETCH_CUSTOM_CATEGORY_SUCCESS = "FETCH_CUSTOM_CATEGORY_SUCCESS";
export const FETCH_CUSTOM_BRAND_SUCCESS = "FETCH_CUSTOM_BRAND_SUCCESS";
export const FETCH_CART_SUCCESS = "FETCH_CART_SUCCESS";
export const ADD_TO_CART_SUCCESS = "ADD_TO_CART_SUCCESS";
export const REMOVE_FROM_CART_SUCCESS = "REMOVE_FROM_CART_SUCCESS";
export const FETCH_DASHBOARD_SUCCESS = "FETCH_DASHBOARD_SUCCESS";
export const ADD_TO_TOKENLESS_CART_SUCCESS = "ADD_TO_TOKENLESS_CART_SUCCESS";
export const REMOVE_FROM_TOKENLESS_CART_SUCCESS = "REMOVE_FROM_TOKENLESS_CART_SUCCESS";